import {
  BASE_ARTICLE_45,
  BASE_MANAGEMENT_AGREEMENT,
} from 'src/app/_services/constants/base-contracts-info';
import { ContractToSignInfo } from 'src/app/_services/types/contract-template.types';
import {
  BusinessInsuredObject,
  getBusinessInsuredObjectLabel,
} from 'src/app/enums/business/business-insured-object.enum';
import {
  BusinessObjectsCover,
  getBusinessObjectsCoverLabel,
} from 'src/app/enums/business/business-object-cover.enum';
import { ContractType } from 'src/app/enums/contract-type.enum';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';
import { SelectElement } from 'src/app/ui-kit/components/select/select.component';

import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';

export const BUSINESS_THINGS_INSURANCE_BASE = 'choses-entreprise';

export const BUSINESS_THINGS_FORM_BASE = `${BUSINESS_INSURANCE_BASE}/${BUSINESS_THINGS_INSURANCE_BASE}`;

export const CONTRACTS_TO_SIGN: ContractToSignInfo[] = [
  {
    ...BASE_ARTICLE_45,
    name: 'Article 45 choses entreprise',
    type: ContractType.ARTICLE_45,
    insuranceType: InsuranceTypeEnum.BUSINESS_COMPANY_THINGS,
  },
  {
    ...BASE_MANAGEMENT_AGREEMENT,
    name: 'Mandat gestion choses entreprise',
    type: ContractType.MANAGEMENT_AGREEMENT,
    insuranceType: InsuranceTypeEnum.BUSINESS_COMPANY_THINGS,
  },
];

// Slider values for franchise
export const REIMBURSED_SUM_VALUES: number[] = [0, 200, 500, 1000, 2000, 5000];

export const REIMBURSED_SUM_LABELS: string[] = ['0', '200', '500', "1'000", "2'000", "5'000"];

// Select options for insured sum
export const INSURED_SUM_OPTIONS: SelectElement<string>[] = [
  { value: '100000', label: "100'000" },
  { value: '500000', label: "500'000" },
  { value: '1000000', label: "1'000'000" },
  { value: 'autres', label: 'Autres' },
];

// Select options for insured objects
export const INSURED_OBJECTS_OPTIONS: SelectElement<BusinessInsuredObject>[] = [
  {
    value: BusinessInsuredObject.GOODS,
    label: getBusinessInsuredObjectLabel(BusinessInsuredObject.GOODS),
  },
  {
    value: BusinessInsuredObject.COMPUTER_HARDWARE,
    label: getBusinessInsuredObjectLabel(BusinessInsuredObject.COMPUTER_HARDWARE),
  },
  {
    value: BusinessInsuredObject.MACHINE_TOOL,
    label: getBusinessInsuredObjectLabel(BusinessInsuredObject.MACHINE_TOOL),
  },
  {
    value: BusinessInsuredObject.OFFICE_FURNITURE,
    label: getBusinessInsuredObjectLabel(BusinessInsuredObject.OFFICE_FURNITURE),
  },
];

// Select options for covers
export const COVERS_OPTIONS: SelectElement<BusinessObjectsCover>[] = [
  {
    value: BusinessObjectsCover.NATURAL_EVENTS,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.NATURAL_EVENTS),
  },
  {
    value: BusinessObjectsCover.WATER_DAMAGE,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.WATER_DAMAGE),
  },
  {
    value: BusinessObjectsCover.ROBBERY,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.ROBBERY),
  },
  {
    value: BusinessObjectsCover.GLASS_BREAKAGE,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.GLASS_BREAKAGE),
  },
  {
    value: BusinessObjectsCover.OPERATING_LOSS,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.OPERATING_LOSS),
  },
  {
    value: BusinessObjectsCover.HYGIENE,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.HYGIENE),
  },
  {
    value: BusinessObjectsCover.CYBER,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.CYBER),
  },
  {
    value: BusinessObjectsCover.EARTHQUAKE,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.EARTHQUAKE),
  },
  {
    value: BusinessObjectsCover.TRANSPORT,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.TRANSPORT),
  },
  {
    value: BusinessObjectsCover.MACHINERY,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.MACHINERY),
  },
  {
    value: BusinessObjectsCover.EPIDEMIC,
    label: getBusinessObjectsCoverLabel(BusinessObjectsCover.EPIDEMIC),
  },
];
